
$(".explosion-box-template .product_gallery_nav.product_gallery_nav--bottom-slider").flickity({
	asNavFor: ".product_gallery",
	adaptiveHeight: false,
	wrapAround: false,
	cellAlign: "center",
	draggable: true,
	groupCells: true,
	prevNextButtons: false,
	pageDots: false,
	lazyLoad: 2,
	dragThreshold: 10,
});

function createInstaStoryCarousel() {
	if (window.innerWidth < 1024) {
		$(".insta-story-icons").flickity({
			adaptiveHeight: false,
			wrapAround: false,
			cellAlign: "left",
			draggable: true,
			groupCells: true,
			prevNextButtons: false,
			pageDots: false,
			lazyLoad: 2,
			dragThreshold: 10,
		});
	} else {
		$(".insta-story-icons").flickity({
			adaptiveHeight: false,
			wrapAround: false,
			cellAlign: "center",
			draggable: true,
			groupCells: true,
			prevNextButtons: false,
			pageDots: false,
			lazyLoad: 2,
			dragThreshold: 10,
		});
	}
}

createInstaStoryCarousel();
$(document).ready(function() {
    $(".box-gifts-selection .gift-option label:first").trigger("click");
});

$(".box-gifts-selection .gift-option label").on("click", function (evt) {
	evt.preventDefault();
	$(".box-gifts-selection .gift-option").removeClass("selected");
	var $containerDiv = $(this).parents(".gift-option");
	$containerDiv.toggleClass("selected");
	$("input#gift_option").val($(this).children("input").val());
});

$(".special-gifts-selection .gift-option label").on("click", function (evt) {
	evt.preventDefault();
	var $containerDiv = $(this).parents(".gift-option");
	$containerDiv.toggleClass("selected");
	$('#back-in-stock-form').show();
});

async function getProductDetails(URLPath) {
	try {
		const data = await fetch(window.location.origin + URLPath);
		const response = await data.json();
		return response;
	} catch (err) {
		console.log(err);
	}
}

$(".box-gifts-selection .gift-option i").modaal({
	type: "inline",
	content_source: ".modal-window",
	before_open: async function (e) {
		// fetch product info
		const modalView = document.querySelector(".modal-view");
		let productHtmlStructure = $(e.currentTarget).parent().find(".eb-variant-details-wrap").html();
		modalView.innerHTML = productHtmlStructure;
		document.querySelector('.addon-modal-btn-container .add_to_order').addEventListener('click', function() {
			const varID = $(this).attr("data-vid");

			if(!$('.box-gifts-selection .gift-option[data-vid="'+ varID +'"]').hasClass("selected")){
				$('.box-gifts-selection .gift-option[data-vid="'+ varID +'"] label').trigger("click");
			}
			$(".box-gifts-selection .gift-option i").modaal('close');

		});
	},
	after_close: function () {
		const modalView = document.querySelector(".modal-view");
		modalView.innerHTML = "";
	},
});


$(".special-gifts-selection .gift-option i").modaal({
	type: "inline",
	content_source: ".modal-window",
	before_open: async function (e) {
		// fetch product info
		const modalView = document.querySelector(".modal-view");
		const productUrl = $(e.currentTarget).parent().find("label img").attr("data-src");
		const productVID = $(e.currentTarget).parent().attr("data-vid");
		let data = await getProductDetails(productUrl);
		let imagesHTML = "";
		if (data.images.length > 0) {
			data.images.forEach((image) => {
				imagesHTML += `<li class="splide__slide"><img src="${image}"></li>`;
			});
		}
		let productHtmlStructure = `
		<h1 class="product_name product_name-pop">Add-ons Items</h1>
		<div class="addon-modal-content">
			<div id="addon_carousel" class="pro_img splide">
				<div class="splide__track">
					<ul id="addon-modal-photos" class="splide__list">
						${imagesHTML}
					</ul>
				</div>
			</div>

			<div class="product-modal-details">
				<p class="product-modal-title">${data.title} </p>
				<div class="product-modal-description" itemprop="description">${data.description}</div>
				<div class="product-details-divider desktop-show"></div>
				<div class="addon-modal-btn-container">
					<a
					href="javascript:;"
					class="action_button add_to_order"
					data-vid="${productVID}"
					>ADD TO ORDER</a
					>
				</div>
			</div>
		</div>`;

		modalView.innerHTML = productHtmlStructure;
		document.querySelector('.addon-modal-btn-container .add_to_order').addEventListener('click', function() {
			const varID = $(this).attr("data-vid");
			if(!$('.special-gifts-selection .gift-option[data-vid="'+ varID +'"]').hasClass("selected")){
				$('.special-gifts-selection .gift-option[data-vid="'+ varID +'"] label').trigger("click");
			}
			$(".special-gifts-selection .gift-option i").modaal('close');
		});
	},
	after_close: function () {
		const modalView = document.querySelector(".modal-view");
		modalView.innerHTML = "";
	},
});

function createDescriptionModal() {
	if (window.innerWidth < 1024) {
		console.log("create description modal");
		$(".anchor-tabs ul li button").modaal({
			type: "inline",
			content_source: ".modal-window",
			before_open: function (e) {
				// fetch product info
				const informationElement = document.querySelector(`div#${e.currentTarget.id}.tab-content`);
				const modalView = document.querySelector(".modal-view");
				modalView.innerHTML = `<div class="modal-tab-content">${informationElement.innerHTML}</div>`;
			},
			after_close: function () {
				const modalView = document.querySelector(".modal-view");
				modalView.innerHTML = "";
			},
		});
	}
}

createDescriptionModal();

window.addEventListener("resize", function () {
	createDescriptionModal();
});

// form input and control
// let imageFiles = [];
// image upload
$(".image-upload-input").on("change", function (event) {
	const files = this.files;
	let imageHTML = `
	<div class="uploaded-image-container">
		<small data-index="${this.id}">x</small>
		<img src="${URL.createObjectURL(files[0])}" class="uploaded_img">
	</div>
	`;
	$(this).parent().hide();
	$(imageHTML).appendTo($(this).parent().parent())
	// $(this).parent().parent().add(imageHTML);
	$(".uploaded-image-container small").on("click", function(event) {
		removeImage(this)
	})
});

function removeImage(element) {
	console.log("clicked small", element);
	$(element).parent().parent().children("label").show();
	$(element).parent().parent().children("label").children("input").val("")
	$(element).parent().remove();
}

// date picker control
$(".date-selection label").on("click", function (event) {
	console.log(event.target.value);
	if (!this.querySelector("input").disabled) {
		if (event.target.value) {
			const dateArray = String(event.target.value).split("/");
			const new_date = new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`);
			console.log(new_date);
			$(".timeslot-selection ul li label").removeClass("active");
			$("#delivery_timeslot").val("");
			$("input#delivery_date").val(event.target.value);
			checkTime(new_date);
			$("#actual-datepicker").hide();
		} else {
			$(".timeslot-selection").hide();
		}
	}
});
// update total price
// calendar renderer

//*****Special Things*******//
let blockedSpecialDates = []
const abSpecialTag = 'vday2026';
const abSpecialDates = ['12/2/2026', '13/2/2026', '14/2/2026','15/2/2026'];
 function abSpecialEventDates(eventDates, tagName) {
     const allItems = document.querySelectorAll('[data-tags]');
    const allItemsHaveTag = Array.from(allItems).every(item => {
        const tags = item.dataset.tags.split(',').map(t => t.trim());
        return tags.includes(tagName);
    });

    const formattedDates = eventDates.map(date => date.replace(/\//g, '-'));
	
    if (allItemsHaveTag && allItems.length > 0) {
      blockedSpecialDates = blockedSpecialDates.filter(date => !formattedDates.includes(date));
    } else {
      blockedSpecialDates = [...new Set([...blockedSpecialDates, ...formattedDates])];
    }
  }
abSpecialEventDates(abSpecialDates, abSpecialTag);
//*****Special Things*******//

function checkTime(new_date) {

	//console.log(new_date);
	$(".timeslot-selection ul label").removeClass("active");
	$(".timeslot-selection ul label").removeClass("not-available");

	var dateDMYYYY =
		new_date.getDate() + "/" + (parseInt(new_date.getMonth()) + 1) + "/" + new_date.getFullYear();


	
	if ($.inArray(dateDMYYYY, timeslot_9to6_dates) != -1) {
		// check for 11AM - 7PM timeslot
		$(".timeslot-selection ul li:lt(4) label").addClass("not-available").hide();
		$(".timeslot-selection ul li:eq(4) label").removeClass("not-available").show();
	} else {
		$(".timeslot-selection ul li:lt(4) label").removeClass("not-available").show();
		$(".timeslot-selection ul li:eq(4) label").addClass("not-available").hide();
	}

		// Hide 6PM-9PM slot on Sundays
	if (new_date.getDay() === 0) { // Sunday is 0
		$(".timeslot-selection ul li:eq(3) label").addClass("not-available").hide();
	} else {
		$(".timeslot-selection ul li:eq(3) label").removeClass("not-available").show();
	}

	if ($("#delivery_date").val() == getCurrentDate()) {
		$(".timeslot-selection ul li input").each(function (index, option) {
			if ($(option).is("[data-hours]")) {
				$(option).parent().removeClass("not-available");
			}
		});
		$(".timeslot-selection ul li input").each(function (index, option) {
			if ($(option).attr("data-hours") <= hour) {
				$(option).attr("disabled", true);
				$(option).parent().addClass("not-available");
			}
		});
	}

	// Check if current time is past 5PM and selected date is tomorrow
	var tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	var tomorrowFormatted = tomorrow.getDate() + "/" + (tomorrow.getMonth() + 1) + "/" + tomorrow.getFullYear();
    const isTomorrow = dateDMYYYY === tomorrowFormatted;
	
	if (hour >= 17 && dateDMYYYY === tomorrowFormatted) {
		// Disable morning slot (data-hours="9") for tomorrow if it's past 5PM today
		$(".timeslot-selection ul li input[data-hours='9']").each(function() {
			$(this).attr("disabled", true);
			$(this).parent().addClass("not-available");
		});
	}

    if(dateDMYYYY == '18/11/2025'){
		$(".timeslot-selection li:nth-child(3) label").addClass("not-available").hide();
		$(".timeslot-selection li:nth-child(4) label").addClass("not-available").hide();
	}

	if(dateDMYYYY == '1/1/2026'){
		$(".timeslot-selection li:nth-child(3) label").addClass("not-available").hide();
		$(".timeslot-selection li:nth-child(4) label").addClass("not-available").hide();
	}

	$(".timeslot-selection").show();
	
	//*******Handle Special things********//
   	function abSpecialEventSlots(dates, slots, cutoffsByIndex) {
		const dateIndex = dates.indexOf(dateDMYYYY);
		const isToday = $('#delivery_date').val() === getCurrentDate();
		
		if (dateIndex !== -1) {
			$('.timeslot-selection ul li label').addClass("not-available").hide();
			slots.forEach(slot => $(`.timeslot-selection li:nth-child(${slot}) label`).removeClass("not-available").show());
			
			const dateCutoffs = cutoffsByIndex[dateIndex] || cutoffsByIndex.default;
			
			slots.forEach(slot => {
				const cutoff = dateCutoffs[slot];
				if (cutoff && ((isTomorrow && hour >= cutoff.prevDay) || (isToday && hour >= cutoff.today))) {
					$(`.timeslot-selection li:nth-child(${slot}) label`).addClass("not-available");
				}
			});

			$(".timeslot-selection").show();
		}
	}
    abSpecialEventSlots(abSpecialDates, [1, 2], {
        0: { 1: {prevDay: 12, today: 0}, 2: {prevDay: 99, today: 12} }, 
        1: { 1: {prevDay: 12, today: 0}, 2: {prevDay: 12, today: 0} }, 
        2: { 1: {prevDay: 12, today: 0}, 2: {prevDay: 99, today: 12} }, 
        default: { 1: {prevDay: 17, today: 0}, 2: {prevDay: 99, today: 12} } // Index 0 & 3
    });
    //*******Handle Special things********//

}


function InitializeDate() {
  $("#actual-datepicker").datepicker("destroy");
$("#actual-datepicker").datepicker({
	inline: true,
	minDate: minDate, // from explosion-box-template
    dateFormat: "dd/mm/yy",
	dayNamesMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	altField: "#datepicker",
	beforeShowDay: function(date){
		return unavailable(date);
	},
	onSelect: function () {
		var tmpArr = $(this).val().split("/");
		var new_date = new Date(tmpArr[1] + "/" + tmpArr[0] + "/" + tmpArr[2]);
		$(".timeslot-selection ul li label").removeClass("active");
		$("#delivery_timeslot").val("");

		$("label[for='choose_a_date'] span").text(tmpArr[0] + "/" + tmpArr[1] + "/" + tmpArr[2]);
		$("label[for='choose_a_date'] input").val(tmpArr[0] + "/" + tmpArr[1] + "/" + tmpArr[2]);
		$("input#delivery_date").val(tmpArr[0] + "/" + tmpArr[1] + "/" + tmpArr[2]);
		$("#actual-datepicker").hide();

		if ($("label[for='choose_a_date'] input").is(":checked")) {
			$("input#delivery_date").val(tmpArr[0] + "/" + tmpArr[1] + "/" + tmpArr[2]);
		}

		checkTime(new_date);
	},
});
}

if (hour >= 17) {
	$("label[for='delivery_today'] span").addClass("not-available");
	$("#delivery_today").attr("disabled", true);
}

$(".calendar-button-wrap").on("click", function (event) {
	event.preventDefault();
	$("#actual-datepicker").show();
});
// timeslot control
$(".timeslot-selection label").on("click", function (event) {
	$(".timeslot-selection label").removeClass("selected");
	if (!$(this).hasClass("not-available")) {
		$(this).addClass("selected");
		$("input#delivery_timeslot").val($(this).children("input").val());
	}
});
// add special gift to cart
async function addSpecialGiftToCart() {
	console.log("add special gifts");
	const items = [];
	const getAllSelectedSpecialGift = document.querySelectorAll(
		".special-gifts-selection .gift-option.selected"
	);
	getAllSelectedSpecialGift.forEach((item) => {
		console.log(item);
		items.push({
			id: item.dataset.vid,
			quantity: 1,
			properties: {
				"Delivery Date": $("#delivery_date").val(),
				"Delivery Time": $("#delivery_timeslot").val()
			}
		});
	});

	const response = await fetch(window.location.origin + "/cart/add.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			items: [...items],
		}),
	});
	const data = await response.json();
}

function isNationwideProduct(title) {
    return title.toLowerCase().includes('nationwide');
}
// Function to check if the product title contains "Valentine"
function isValentineProduct(title) {
    return title.toLowerCase().includes('valentine');
}


/**
 * form validation
 *
 * check for gift selection
 * check for special addons
 * check for delivery date and time selection
 * save card message if any
 */
async function formValidation() {
	try {
		// const formData = new FormData(document.querySelector("form.shopify-product-form"));
		// const imageInput = document.querySelectorAll(".image-upload-input");

		const giftOptionInput = document.querySelector("#gift_option");
		const cardMessageInput = document.querySelector("#card_message");
		const imageUploadInput = document.querySelector("#image_upload");
    var productTitle = document.getElementById('productTitle').textContent;
 if (!isNationwideProduct(productTitle)) {
   const deliveryDateInput = document.querySelector("#delivery_date");

   const deliveryTimeInput = document.querySelector("#delivery_timeslot");

   if (!deliveryDateInput.value  ) {
			alert("Please select a delivery date to proceed.");
			return;
		}

		if (!deliveryTimeInput.value) {
			alert("Please select a delivery timeslot to proceed.");
			return;
		}
 }

		if (!giftOptionInput.value) {
			alert("Please select a gift to proceed.");
			return;
		}

		await addSpecialGiftToCart();
		$("form.shopify-product-form").trigger("submit");


	} catch (error) {
		console.error(error);
	}
}

$(".fake-submit-button").on("click", function () {
	formValidation();
});


$(document).ready(function () {
  $(".special-gifts-selection .gift-option").on('click', function() {
    console.log("Gift option clicked"); // Debug log
    
    // Reset date inputs
    $("#delivery_date").val("");
    $("#delivery_timeslot").val("");
    
    // Reset the choose date label and input
    $("label[for='choose_a_date'] input").val("");
    $("label[for='choose_a_date'] span").text("Choose Your Delivery Date");
    
    // Hide datepicker
    $("#actual-datepicker").hide();
    
    // Hide timeslot selection if it's visible
    $(".timeslot-selection").hide();
    
    // Reinitialize the datepicker
    InitializeDate();
  });

  InitializeDate();
});

//===================vDay 2025 Functionality ==============================

